export default "<app-repository-policy-termination-form></app-repository-policy-termination-form>\n";